export default __webpack_public_path__ + "static/media/s5Tournaments.b56f3602.png";